import { render } from "./index.vue?vue&type=template&id=7d8b04c6"
import script from "./vendorPortal.js?vue&type=script&lang=js&external"
export * from "./vendorPortal.js?vue&type=script&lang=js&external"

import "./vendorPortal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__